import { Link } from 'react-router-dom';
import React from 'react';

import Countdown from 'react-countdown';
import countdownRenderer from '../../components/countdownRenderer';

import { Carousel, Card } from '../../components/Carousel/Carousel';


import './local.scss';

export default function Home() {

  const DiscordButton = () => {
    return (
      <a target="_blank" href="https://discord.gg/dpHftmYJE4">
        <button className="-discord -wide -gradient">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clipPath="url(#clip0_732_31773)"><path d="M20.3175 4.49295C18.7875 3.80295 17.1475 3.29295 15.4325 3.00295C15.4172 3.00002 15.4014 3.00191 15.3872 3.00836C15.3731 3.01481 15.3613 3.0255 15.3535 3.03895C15.1435 3.40795 14.9095 3.88895 14.7455 4.26895C12.9266 3.99719 11.0774 3.99719 9.25848 4.26895C9.07582 3.84781 8.86983 3.43717 8.64148 3.03895C8.63374 3.02533 8.62203 3.0144 8.60792 3.00761C8.5938 3.00082 8.57795 2.9985 8.56248 3.00095C6.84848 3.29095 5.20848 3.80095 3.67748 4.49195C3.66431 4.49747 3.65314 4.5069 3.64548 4.51895C0.533481 9.09395 -0.319519 13.556 0.0994806 17.962C0.100647 17.9727 0.103996 17.9832 0.109326 17.9926C0.114655 18.0021 0.121853 18.0104 0.130481 18.017C1.94687 19.3394 3.97282 20.3468 6.12348 20.997C6.13847 21.0016 6.15451 21.0016 6.16949 20.9969C6.18448 20.9923 6.19772 20.9832 6.20748 20.9709C6.66948 20.3509 7.08148 19.6959 7.43348 19.0079C7.45448 18.9679 7.43448 18.9199 7.39248 18.9039C6.74649 18.6607 6.12057 18.3671 5.52048 18.0259C5.5097 18.0198 5.50061 18.0111 5.49404 18.0005C5.48746 17.99 5.48361 17.978 5.48281 17.9656C5.48202 17.9532 5.48432 17.9408 5.48949 17.9295C5.49467 17.9183 5.50257 17.9084 5.51248 17.9009C5.63848 17.8079 5.76448 17.711 5.88448 17.614C5.89528 17.6052 5.90829 17.5997 5.92206 17.5979C5.93584 17.5961 5.94983 17.5982 5.96248 17.604C9.88948 19.368 14.1425 19.368 18.0235 17.604C18.0362 17.5979 18.0503 17.5955 18.0643 17.5971C18.0782 17.5987 18.0915 17.6042 18.1025 17.6129C18.2225 17.7109 18.3475 17.8079 18.4745 17.9009C18.4845 17.9083 18.4925 17.918 18.4979 17.9292C18.5032 17.9403 18.5057 17.9527 18.5051 17.9651C18.5045 17.9774 18.5008 17.9895 18.4945 18.0001C18.4881 18.0107 18.4791 18.0196 18.4685 18.0259C17.8705 18.3699 17.2485 18.661 16.5955 18.903C16.5855 18.9066 16.5763 18.9123 16.5687 18.9198C16.561 18.9272 16.5551 18.9362 16.5512 18.9462C16.5473 18.9561 16.5456 18.9668 16.5462 18.9774C16.5467 18.9881 16.5496 18.9985 16.5545 19.0079C16.9145 19.695 17.3265 20.3489 17.7795 20.9699C17.7889 20.9827 17.802 20.9922 17.8171 20.9972C17.8321 21.0022 17.8483 21.0025 17.8635 20.9979C20.0178 20.3496 22.0471 19.3417 23.8655 18.017C23.8744 18.0107 23.8818 18.0027 23.8873 17.9934C23.8928 17.9841 23.8963 17.9737 23.8975 17.9629C24.3975 12.8689 23.0595 8.44295 20.3485 4.52095C20.3418 4.5082 20.3308 4.49827 20.3175 4.49295ZM8.02048 15.2789C6.83848 15.2789 5.86348 14.2099 5.86348 12.8989C5.86348 11.5869 6.81948 10.5189 8.02048 10.5189C9.23048 10.5189 10.1965 11.5959 10.1775 12.8989C10.1775 14.2109 9.22148 15.2789 8.02048 15.2789ZM15.9955 15.2789C14.8125 15.2789 13.8385 14.2099 13.8385 12.8989C13.8385 11.5869 14.7935 10.5189 15.9955 10.5189C17.2055 10.5189 18.1715 11.5959 18.1525 12.8989C18.1525 14.2109 17.2065 15.2789 15.9955 15.2789Z" fill="white"/></g><defs><clipPath id="clip0_732_31773"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>
          Join us on Discord
        </button>
      </a>
    )
  }

  


  return (
    <>
      <section className="common--umbro-nations">
        <Carousel>
          <Card src={require('../../i/nft-stills/england.jpg')} />
          <Card src={require('../../i/nft-stills/england_away.jpg')} />
          <Card src={require('../../i/nft-stills/brazil.jpg')} />
          <Card src={require('../../i/nft-stills/germany.jpg')} />
          <Card src={require('../../i/nft-stills/france.jpg')} />
          <Card src={require('../../i/nft-stills/spain.jpg')} />
          <Card src={require('../../i/nft-stills/usa.jpg')} />
          <Card src={require('../../i/nft-stills/mexico.jpg')} />
        </Carousel>
        <div className="text">
          <h2>Meet the UmbroIDs</h2>
          <p>2022 has set the stage for the biggest tournament in world football. But this time, it’ll be the first ever to be staged in the Middle East since the competition began in 1930. Umbro has been at the heart and soul of sport since 1924. Now, it’s time for Umbro’s next big first.</p>
          <p>The UmbroID Limited Collection. 808 Special Edition Digital Collectibles commemorating this major footballing milestone, and Umbro’s role in shaping and equipping the beautiful game across the decades.</p>
          <p>You’ve collected stickers. You’ve collected playing cards. Badges. Pins. Shirts. Now get your hands on the first ever digital collectibles issued by one of the most iconic sports brands of the last 100 years, exclusively here, on DNIZN.</p>

          <Countdown
            date={Date.parse('2 Dec 2022 21:00:00 GMT')}
            renderer={countdownRenderer}
          />

        </div>
      </section>

      <div className="common-hero"> 
        <section>
          <div className="text">
            <h2>Smart digital collectibles from your favourite brands.</h2>
            <p>DNIZN is not “Crypto”. DNIZN is for the collectors. It’s the digital home of your favourite brands. Connect. Collect. Become a DNIZN.</p>
            <p>At DNIZN, we’re redefining NFTs. And taking them mainstream. Because digital collectibles should be available to anyone and everyone. And their authenticity should be guaranteed.</p>
            <p>This is DNIZN. A safe digital space for people and brands to inhabit, explore, and engage.</p>
            <Link to="/about">
              <button className="-wide">More About DNIZN</button>
            </Link>
          </div>
          <div className="image" />
        </section>
      </div>

      <section className="home-community">
        <div className="text">
          <h2>Be A Part Of The Community</h2>
          <p>DNIZN is your digital habitat. And you, our DNIZNs, are its inhabitants. We’re a community of brands and consumers. You speak. They listen. They speak. You’ll be the first to know. And the first in line.</p>
          <p>Whether it’s limited-edition Digital Collectibles sales or exclusive digital giveaways from your favourite brands. To be first, you have to be there. With DNIZN, on Discord.</p>
          <DiscordButton />
        </div>
        <div className="image"></div>
      </section>
    </>
  );
};
